module.exports = __webpack_public_path__ + "img/fb3550c.png";